import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import { Link } from 'react-router-dom';
import TimeAgo from 'react-timeago';
import RoutingService from '../../services/RoutingService';
import RESTService from '../../services/RESTService';
import CreateTenantModal from './create-tenant-modal/CreateTenantModal';
import Spinner from '../../components/spinner/Spinner';
import './tenant-list.css';
import AuthService from '../../services/AuthService';

const connect = new RESTService();
const RS = new RoutingService();
const auth = new AuthService();

class TenantList extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			searchText: '',
			filterValue: 'active',
			archived: 0,
			tenants: [],
			activeModal: null,
			loading: true,
			openMenu: null,
			filteredTenants: function() {
				//Filter out api testing tenants that get created everyday
				//TODO make proper filters for active/archived once we have that working
				return this.tenants
					? this.tenants.filter(tenant => {
							let check =
								tenant.name.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 && (this.filterValue === 'active' ? !tenant.archived : false);
							if (check && auth.hasPlatformRole()) {
								return check;
							} else if (check && !auth.hasPlatformRole() && auth.getAvailableTenants().length > 0) {
								return auth.getAvailableTenants().indexOf(tenant.name) >= 0;
							}
							return [];
					  })
					: [];
			}
		};
		this.autoBind([
			'getTenants',
			'buildTenantListItems',
			'onTenantClick',
			'onSearchChange',
			'onSortChange',
			'createTenant',
			'onCloseCreate',
			'onHandleCreate'
		]);
	}

	componentDidMount() {
		this.getTenants();
	}

	getTenants() {
		connect
			.getTenants()
			.then(res => {
				this.observe(() => {
					this.data.tenants = res.data;
					let ct = 0;
					res.data.forEach(t => {
						if (t.archived) {
							ct++;
						}
					});
					this.data.archived = ct;
					this.data.loading = false;
				});
			})
			.catch(err => {
				this.setData('loading', false);
				RS.smartError(err);
			});
	}

	onCloseOpenMenu = () => {
		if (this.data.openMenu) {
			this.data.openMenu.classList.add('hidden');
			this.setData('openMenu', null);
		}
	};

	onTenantClick(evt) {
		let name = evt.currentTarget.dataset.tenant;
		if (name) {
			RS.setCurrentTenant(name);
			RS.setCurrentEnvironment('dev');
			RS.setCurrentApplication(null);
			RS.setCurrentConfiguration(null);
		}
		if (this.data.openMenu) {
			this.data.openMenu.classList.add('hidden');
			this.setData('openMenu', null);
		}
		if (evt.target.classList.contains('mdi-dots-vertical')) {
			evt.preventDefault();
			let el = evt.target.parentElement.getElementsByClassName('menu-items')[0];
			if (el && el.classList.contains('hidden')) {
				el.classList.remove('hidden');
				this.setData('openMenu', el);
			}
		}
		if (evt.target.classList.contains('item')) {
			evt.preventDefault();
		}
	}

	setArchived = () => {
		this.setData('filterValue', 'archived');
	};

	setActive = () => {
		this.setData('filterValue', 'active');
	};

	onSortChange(evt) {
		this.setData('sortValue', evt.target.value);
	}

	onSearchChange(evt) {
		this.setData('searchText', evt.target.value);
	}

	createTenant() {
		this.setData('activeModal', 'create-tenant');
	}

	onCloseCreate() {
		this.setData('activeModal', null);
	}

	onHandleCreate(data) {
		connect
			.createTenant({
				name: data.tenantName,
				logPersonalIdentifyingInfo: data.logPersonalIdentifyingInfo
			})
			.then(res => {
				RS.showSuccess();
				RS.setCurrentTenant(res.data.name);
				RS.setCurrentEnvironment(null);
				RS.goToRoute(`/tenant-management/${res.data.name}/environments`);
			})
			.catch(err => {
				this.setData('loading', false);
				RS.smartError(err);
			});
		this.setData('activeModal', null);
	}
	onShowMetadata = evt => {
		let id = evt.target.dataset.tenant;
		console.log(id);
		evt.preventDefault();
	};
	onManageLicense = evt => {
		let id = evt.target.dataset.tenant;
		console.log(id);
		evt.preventDefault();
	};

	buildTenantListItems() {
		let tenants = this.data.filteredTenants();
		tenants.sort(function(a, b) {
			return a.name > b.name;
		});
		let items = [];
		if (auth.isPlatformAdmin()) {
			items.push(
				<a className="create-card" onClick={this.createTenant} key={'create-tenant-card'}>
					<div className="tenant-card shadow hover animated zoomIn">
						<div className="card-header vbox vcenter hcenter">
							<div className="name ellipse">Create Tenant</div>
						</div>
						<div className="card-center vbox hcenter vcenter">
							<i className="mdi mdi-plus" />
						</div>
						<div className="card-bar" />
					</div>
				</a>
			);
		}
		for (let i = 0; i < tenants.length; i++) {
			let tenant = tenants[i];
			items.push(
				<Link to={'/tenant-management/' + tenant.name + '/environments'} data-tenant={tenant.name} key={tenant._id} onClick={this.onTenantClick}>
					<div className="tenant-card shadow hover animated zoomIn">
						<div className="card-header vbox vcenter hcenter">
							<div className="name ellipse" title={tenant.name}>
								{tenant.name}
							</div>
						</div>
						<div className="card-center vbox hcenter vcenter">
							<i className="mdi mdi-server" />
						</div>
						<div className="card-bar hbox vcenter hright">
							<div className="created">
								Created: <TimeAgo date={tenant.creationDate} />
							</div>
							<div className="options vbox hcenter vcenter">
								<i className="mdi mdi-dots-vertical" title="Manage Licensed Applications" />
								<div className="menu-items animated zoomIn hidden">
									<div className="item hbox vcenter" data-tenant={tenant._id} onClick={this.onManageLicense}>
										<i className="mdi mdi-settings" /> Manage License
									</div>
									<div className="item hbox vcenter" data-tenant={tenant._id} onClick={this.onShowMetadata}>
										<i className="mdi mdi-code-tags" /> Metadata
									</div>
								</div>
							</div>
						</div>
					</div>
				</Link>
			);
		}
		return items;
	}

	render() {
		let { searchText, filterValue, activeModal, archived, loading, openMenu } = this.data;

		return (
			<div className="tenant-list-view animated fadeIn">
				{openMenu && <div className="menu-mask" onClick={this.onCloseOpenMenu} />}
				<div className="tenants-header hbox vcenter">
					<div className="header-text grow-1">My Tenants</div>
				</div>
				<div className="list-header hbox vbottom animated fadeIn">
					<div className={`header-tab vbox vcenter hcenter ${filterValue === 'active' ? 'active' : ''}`} onClick={this.setActive}>
						Active {`(${this.data.filteredTenants().length - archived})`}
					</div>
					<div className={`header-tab vbox vcenter hcenter ${filterValue === 'archived' ? 'active' : ''}`} onClick={this.setArchived}>
						Archived {`(${archived})`}
					</div>
					<div className="grow-1" />
					<div className="search-ctn hbox vcenter">
						<i className="mdi mdi-magnify" />
						<input className="search-input" value={searchText} onChange={this.onSearchChange} placeholder="Search Tenants..." />
					</div>
				</div>
				<div className="tenant-card-list">{loading ? <Spinner height="400px" text="Loading Tenants" /> : this.buildTenantListItems()}</div>
				<CreateTenantModal isOpen={activeModal === 'create-tenant'} onCancel={this.onCloseCreate} onConfirm={this.onHandleCreate} />
			</div>
		);
	}
}

export default TenantList;



// WEBPACK FOOTER //
// ./src/views/tenant-list/TenantList.js